// แปลง byte เป็นข้อความ base64 เพื่อส่งข้อมูลถิ่นที่อยู่ (BLOB) ไปกับ JSON
// ใช้ btoa/atob ที่มีทั้งใน Workers เบราว์เซอร์ และ Node

export function bytesToBase64(bytes: Uint8Array): string {
  let s = "";
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(s);
}

export function base64ToBytes(text: string): Uint8Array {
  const s = atob(text);
  const out = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i);
  return out;
}
